import { FC, useState } from 'react';

import './Tabs.scss';
import { Tab } from '../../SharedTypes/Models';

export type Props = {
	selectedTab: number;
	items: Tab[];
	onChange: (newTab: number) => void;
};


export const Tabs:  FC<Props> = ({selectedTab, items, onChange}) => {

	const handleTabChange = (tab: number) => {
		onChange(tab);
	}

	return(
		<div className="c-tabs">
			<div className='c-tabs__wrapper'>
				{
					items &&
					items.map((item) => {
						return(
							<div className={selectedTab == item.key ? `c-tabs__item c-tabs__item--active` : `c-tabs__item`} 
								onClick={() => handleTabChange(item.key)}
								key={item.key}>
								{item.title}
							</div>
						)
					})
				}
			</div>
		</div>
	);
};

